




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
//  types
import { CellData, DataQualityHeader, DataQualityRow } from "@/types/dataQuality/dataQualityTable";
//  components
import DataCell from "./DataCell.vue";
//  modules
import { getModule } from "vuex-module-decorators";
import UserModule from "@/store/clients/User.module";

const User = getModule(UserModule, store);

@Component({
  components: {
    DataCell,
  },
})
export default class DataAvailabilityTable extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: Boolean;
  @Prop({ type: Array, default: () => [] }) headers!: DataQualityHeader[];
  @Prop({ type: Array, default: () => [] }) rows!: DataQualityRow[];
  @Prop({ type: Array, default: () => [] }) links!: string[] | null;

  isLoadingTextDisplay = false;
  sortBy = "";
  sortDesc = false;
  limitPerPage = 10;
  pageCount = 0;
  currentItems: DataQualityRow[] = [];
  currentPage = 1;

  //  @Getters
  get isLessThanLimitPerPage(): boolean {
    return this.rows.length <= this.limitPerPage;
  }

  get indicatorsCount(): number {
    return this.headers.length;
  }

  get skeletonStructure(): object {
    return { "table-row": "table-cell@6" };
  }


  highlightRedirectedVessel(item: DataQualityRow, rowIndex: string): boolean {
    const vesselQuery = this.$route.query.find;
    if (!vesselQuery) return false;

    const match = item.vesselName.value.includes(vesselQuery);
    if (match) {
      setTimeout(() => {
        if (!this.$refs[`rowIndex${rowIndex}`]) return;
        (this.$refs[`rowIndex${rowIndex}`] as any).classList.remove("redirected");
      }, 8000);
    } else {
      const redirectedVesselRowIndex = this.rows.findIndex((row: DataQualityRow) => row.vesselName.value.includes(vesselQuery));
      if (redirectedVesselRowIndex === -1) return false;
      const pageIndex = Math.floor(redirectedVesselRowIndex / this.limitPerPage);
      this.currentPage = pageIndex + 1; // Update the page to the correct page index
      setTimeout(() => {
        Object.keys(this.$refs).forEach((key: any) => {
          if ((this.$refs[key] as any).classList.contains("redirected")) (this.$refs[key] as any).classList.remove("redirected");
        });
      }, 8000);
    }
    return match;
  }

  headerClasses(header: any): any {
    return [
      header.class,
      {
        sortable: header.sortable,
        "no-sort": this.sortBy !== header.value,
      },
    ];
  }

  headerStyles(header: any): any {
    return {
      width: header.width ? header.width : "auto",
      "min-width": header.width ? header.width : "auto",
    };
  }

  sort(value: string): void {
    if (!value) return;
    if (this.sortBy === value) {
      this.sortDesc = !this.sortDesc;
    } else {
      this.sortBy = value;
      this.sortDesc = false;
    }
  }

  cellData(row: DataQualityRow, header: DataQualityHeader, index: number): any {
    return {
      column: header.value,
      columnName: header.text,
      type: header.type,
      value: row[header.value].value,
      link: row[header.value].link,
      align: header.align,
      lastDataTimestamp: row[header.value].lastDataTimestamp,
      outageStartTime: row[header.value].outageStartTime,
      outageDetectionTime: row[header.value].outageDetectionTime,
    };
  }

  //  @Hooks
  async created() {
    setTimeout(() => ((this as any).isLoadingTextDisplay = true), 3000);
  }
}
